import React from 'react';
import NFTUserAvatar from '../../components/NFTUserAvatar';
import useNFTUserData from '../../data/useNFTUserData';
import INFTBestUser from '../../models/INFTBestUser';
import { getWalletAddress } from '../../utils/NFTFormatedData';
import { TopSellerItem, TopSellerImage, TopSellerTitle, TopSellerDescription } from './styled';
import { ReactComponent as VerifiedIcon } from '../../../../assets/svg/verified.svg'
import { useHistory } from 'react-router-dom';

const DashboardTopUser = (props: { data: INFTBestUser, type: "seller" | "buyer" }) => {
    const { userData } = useNFTUserData(props.data.address.toLowerCase());
    const navigator = useHistory();

    const handleClick = React.useCallback(() => {
        navigator.push(`/profile/${props.data.address.toLowerCase()}`);
    }, [])

    return (
        <TopSellerItem onClick={handleClick}>
            <TopSellerImage>
                <NFTUserAvatar
                    key={props.data.address}
                    accountAddress={props.data.address}
                    height={120}
                    width={120}
                    profileImgUrl={userData?.profileImgUrl}
                />
                {userData?.isVerified && <VerifiedIcon />}
            </TopSellerImage>
            <TopSellerTitle>{userData?.username ?? getWalletAddress(props.data.address, 6)}</TopSellerTitle>
            <TopSellerDescription>{`${props.type == "buyer" ? "Bought" : "Sold"} ${props.data.count} NFTs`}</TopSellerDescription>
        </TopSellerItem>
    )
}

export default React.memo(DashboardTopUser);